import { render, staticRenderFns } from "./DealUpsellCallout.vue?vue&type=template&id=44c607d2&scoped=true&"
import script from "./DealUpsellCallout.vue?vue&type=script&lang=js&"
export * from "./DealUpsellCallout.vue?vue&type=script&lang=js&"
import style0 from "./DealUpsellCallout.vue?vue&type=style&index=0&id=44c607d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c607d2",
  null
  
)

export default component.exports